import React from 'react';

class HomeIndexContainer extends React.Component {
    render() {
        return(<React.Fragment></React.Fragment>);
    }
}

export default HomeIndexContainer;


// WEBPACK FOOTER //
// ./src/Components/Containers/Home/Index.js